module.exports = __webpack_public_path__ + "static/media/feature_2.df3f4878.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/landing/feature_2.png
// module id = 1251
// module chunks = 0